import * as tslib_1 from "tslib";
import { schema } from '../redux/normalizr';
import { deviationSchema } from '../redux/normalizr/schemas/deviation';
import { userSchema } from '../redux/normalizr/schemas/user';
var calculateEntityId = function (_a) {
    var user = _a.user;
    return "" + user.userId;
};
var processStrategy = function (entity) { return (tslib_1.__assign({}, entity, { id: calculateEntityId(entity) })); };
export var watchSuggestionSchema = new schema.Entity('watchSuggestion', {
    user: userSchema,
    deviations: [deviationSchema],
}, {
    idAttribute: calculateEntityId,
    processStrategy: processStrategy,
});
//# sourceMappingURL=schemas.js.map